import { render, staticRenderFns } from "./facebook-share.vue?vue&type=template&id=004ba1ca"
import script from "./facebook-share.vue?vue&type=script&lang=js"
export * from "./facebook-share.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports